import { AppTableFilters } from "../../services/AppTableFilters";

export const createSorter = (appTableFiltersInstance: AppTableFilters, column: string, type: 'date' | 'text' | 'number' = 'text') => {
  return {
    id: column,
    getValue: () => appTableFiltersInstance.getSorter(column)?.value,
    isActive: () => appTableFiltersInstance.isSorterActive(column),
    onSort: () => {
      if (appTableFiltersInstance.isSorterActive(column)) {
        const currentSorter = appTableFiltersInstance.getSorter(column);
        if (currentSorter?.value === 'asc') {
          appTableFiltersInstance.updateSorter(column, 'desc');
        } else {
          appTableFiltersInstance.removeSorter(column);
        }
      } else {
        appTableFiltersInstance.clearSorters();
        appTableFiltersInstance.addSorter({
          id: column,
          type: type,
          field: column,
          value: 'asc',
          active: true
        });
      }
    },
  };
};

export const createFilter = (
    appTableFiltersInstance: AppTableFilters,
    type: 'textfields' | 'select' | 'radio' | 'multioption',
    column: string,
    label: string,
    options?: { label: string, value: string }[] | ((columnName) => { label: string, value: string }[]),
    filterFunc?: (item: any, value: any) => boolean,
    field?: string) => {

    const opts = (options !== undefined && typeof options === 'function')
        ? options(column)
        : options;

    return {
        id: column,
        type: type,
        field: field !== undefined ? field : column,
        label: label,
        value: '',
        options: opts,
        onApply: (value) => {
            if (value) {
                appTableFiltersInstance.addFilter({
                    id: column,
                    type: type,
                    label: `${label}: ${type === 'textfields' ? value[column] : type === 'multioption' ? value.join(', ') : value}`,
                    field: field !== undefined ? field : column,
                    value: type === 'textfields' ? value[column] : value,
                    options: opts,
                    filteringFn: filterFunc !== undefined
                        ? filterFunc
                        : undefined
                });
            }
        },
        inputs:
            [
                {
                    id: column,
                    // this is the field inside the data object that should be used to filter the data
                    field: column,
                    label: label,
                    value: '',
                }
            ]
    }
};
